import { useCallback, useState } from 'react';
import { ThemeMode } from '@libs/theme';
import { getPreselectedTheme, STORAGE_THEME_KEY } from '@libs/helpers';
export const useThemeModeToggler = (jurisdictionId) => {
    const [selectedTheme, setSelectedTheme] = useState(getPreselectedTheme(jurisdictionId));
    const toggleThemeMode = useCallback(() => {
        setSelectedTheme((prev) => prev === ThemeMode.light ? ThemeMode.dark : ThemeMode.light);
    }, []);
    const handleThemeChange = useCallback((theme) => {
        localStorage.setItem(STORAGE_THEME_KEY, theme);
        setSelectedTheme(theme);
    }, []);
    return {
        selectedTheme,
        selectTheme: handleThemeChange,
        toggleThemeMode,
    };
};
//# sourceMappingURL=useThemeModeToggler.js.map